import { useAuth } from '@/lib/auth'
import { captureException } from '@/lib/errors'
import { performMutations, useMutation } from '@/lib/mutations'
import { useStore } from '@/lib/pocketbase'

interface BulkApproveTimeEntriesData {
    entryIds: string[]
    orgId: string
}

export function useBulkApproveTimeEntries() {
    const { user } = useAuth()
    const [timeEntriesCollection] = useStore('time_entries')

    const mutation = useMutation({
        mutationFn: async (data: BulkApproveTimeEntriesData) => {
            if (!user?.id) {
                throw new Error('User not found')
            }

            const now = new Date().toISOString()

            return await performMutations(function* () {
                yield data.entryIds.map(entryId =>
                    timeEntriesCollection.update(entryId, draft => {
                        draft.status = 'approved'
                        draft.approved_by = user.id
                        draft.approved_at = now
                        draft.rejection_reason = ''
                    })
                )
            })
        },
        onError: error => {
            captureException('Bulk approve time entries failed', error)
        },
    })

    return {
        mutate: mutation.mutate,
        mutateAsync: mutation.mutateAsync,
        isPending: mutation.isPending,
    }
}
